import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

function setTriptychSlider(slider) {
    // eslint-disable-next-line no-new
    const progressBar = slider.querySelector('.triptych__progress');
    const autoplay = 1000;

    new Swiper(slider, {
        loop: true,
        speed: 1200,
        autoplay: {
            delay: autoplay,
            disableOnInteraction: false,
        }
    });
}

document.querySelectorAll('.js-triptych-slider').forEach(setTriptychSlider);
